export const methods = {
  prevStep() {},
  nextStep() {},
  open() {
    this.isOpen = true
  }
}
